import { Dispatch } from "redux";
import { updateServerValidation } from "../reducers/metaReducer";
import * as metaReducer from "../reducers/metaReducer";
import IErrorVm from "../models/home/Error/IErrorVm";

require("es6-promise").polyfill();
require("isomorphic-fetch");
const camelcaseKeys = require("camelcase-keys-deep");
// import * as camelcaseKeys from "camelcase-keys-deep"

export default class Http {
  public static dispatch: Dispatch<any> = null;

  public static async post<T, S = T>(url: string, body: T, useAsyncMarker: boolean = true, handleErrors: boolean = true): Promise<S> {
    let fetchPromise = null;
    try {
      if (useAsyncMarker) {
        this.dispatch(metaReducer.setAsyncRunning(true));
      }

      const headers = new Headers();
      headers.append("Accept", "application/json, application/xml, text/plain, text/html, *.*");
      headers.append("Content-Type", "application/json; charset=utf-8");
      headers.append("__RequestVerificationToken", (window as any).__RequestVerificationToken);
      headers.append("pragma", "no-cache");
      headers.append("cache-control", "no-cache");
      headers.append("X-IsAjaxRequest", "true");
      fetchPromise = await fetch(process.env.SERVER + url, {
        body: JSON.stringify(body),
        credentials: "include",
        method: "POST",
        headers,
        redirect: "manual",
      });

      this.writeToken(fetchPromise.headers);
      const result = await fetchPromise.text();
      if (!fetchPromise.ok && handleErrors) {
        const fetchType = fetchPromise.type.toString();
        this.handleErrors(result, fetchType);
        // throw new Error("Http error")
      }
      if (await this.checkForUnhandledErrors(result)) {
        // throw new Error("Unknown error")
      }
      return camelcaseKeys(JSON.parse(result) as T);
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      if (useAsyncMarker) {
        this.dispatch(metaReducer.setAsyncRunning(false));
      }
    }
  }

  public static async get<T>(url: string, useAsyncMarker: boolean = true): Promise<T> {
    let fetchPromise = null;
    try {
      if (useAsyncMarker) {
        this.dispatch(metaReducer.setAsyncRunning(true));
      }

      const headers = new Headers();
      headers.append("Accept", "application/json, application/xml, text/plain, text/html, *.*");
      headers.append("Content-Type", "application/json; charset=utf-8");
      headers.append("__RequestVerificationToken", (window as any).__RequestVerificationToken);
      headers.append("pragma", "no-cache");
      headers.append("cache-control", "no-cache");
      headers.append("X-IsAjaxRequest", "true");
      fetchPromise = await fetch(process.env.SERVER + url, {
        credentials: "include",
        method: "GET",
        headers,
        redirect: "manual",
      });
      this.writeToken(fetchPromise.headers);
      const result = await fetchPromise.text();
      if (!fetchPromise.ok) {
        const fetchType = fetchPromise.type.toString();
        this.handleErrors(result, fetchType);
        throw new Error("Http error");
      }
      if (await this.checkForUnhandledErrors(result)) {
        throw new Error("Unknown error");
      }
      return camelcaseKeys((await JSON.parse(result)) as T);
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      if (useAsyncMarker) {
        this.dispatch(metaReducer.setAsyncRunning(false));
      }
    }
  }
  private static writeToken(headers: Headers): void {
    (window as any).__RequestVerificationToken = headers.get("__RequestVerificationToken");
  }

  private static async checkForUnhandledErrors(resp: string): Promise<boolean> {
    if (resp.indexOf("<html>") > -1 && resp.indexOf("__RequestVerificationToken") > -1) {
      this.dispatch(updateServerValidation([{ message: "TEXT_USER_LOGGED_OUT" }] as IErrorVm[]));
      return true;
    }
    return false;
  }

  private static async handleErrors(result: string, fetchType: string) {
    try {
      if (fetchType === "opaqueredirect") {
        // manual redirect
        this.dispatch(updateServerValidation([{ message: "TEXT_USER_LOGGED_OUT" }] as IErrorVm[]));
      } else {
        const errors = camelcaseKeys(JSON.parse(result));
        this.dispatch(updateServerValidation(Array.isArray(errors) ? errors : [errors]));
      }
    } catch (error) {
      this.dispatch(updateServerValidation([{ message: "" }] as IErrorVm[]));
    }
  }
}
